
<template>
  <v-container fluid class="px-5 pt-3">
    <v-row class="pa-3" align='center'>
      <span class="title font-weight-bold">{{ $t('pages.agenda') }}</span>
      <v-spacer></v-spacer>
    </v-row>
    <v-row class="pa-3" align='center'>
      <v-col cols="12" md="12">
        <base-card :with_title="false">
          <template v-slot:content>
            <div v-if="1">
              <the-calendar ></the-calendar>
            </div>
            <card-loading-transparent v-if="0"></card-loading-transparent>
            <!-- <div v-if="!loading && !tasks.length">
              {{ $t('tasks.none') }}
            </div> -->
          </template>
          <template slot="actions">
            <p></p>
            <!-- <v-btn text small class="text-capitalize" color="blue-grey">{{ $tc('see_all',3) }}</v-btn> -->
          </template>
        </base-card>
      </v-col>
      <!-- <v-col cols="12" md="6"> -->
        <!-- <my-tasks-card></my-tasks-card> -->
      <!-- </v-col> -->
    </v-row>
    <router-view></router-view>
  </v-container>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import CalendarCard from '../../components/homepage/cards/CalendarCard.vue'
import TheCalendar from '../../components/shared/TheCalendar2.vue'
//import validations from '@/mixins/validations'
//import Api from '@/api/index';

export default {
  name: 'AgendaPage',
  //mixins: [ validations ],
  components: {
    CalendarCard,
    TheCalendar
    //ComponentName: () => import(''),
  },
  data() {
    return {
      
    }
  },
  methods: {
    name() {
      
    },
    ...mapActions({
      // function: 'Module/action'
      //addNotification: 'Notification/add'
    })
  },
  computed: {
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
}
</script>

<style scoped>

</style>